import { Link } from 'react-router-dom';

const footerLinks = {
  explore: [
    { label: 'Home', to: '/' },
    { label: 'Shopping Guide', to: '/guide/shopping' },
    { label: 'Trusted Sellers', to: '/article/trusted-cssbuy-sellers' },
    { label: 'CSSBuy Spreadsheet Guide', to: '/article/cssbuy-spreadsheet-guide' },
    { label: 'Shoes', href: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  ],
  agent_hubs: [
    { label: 'CSSBuy Spreadsheet', to: '/' },
    { label: 'Kakobuy Spreadsheet', to: '/hub/kakobuy-spreadsheet' },
    { label: 'Superbuy Spreadsheet', to: '/hub/superbuy-spreadsheet' },
    { label: 'Oopbuy Spreadsheet', to: '/hub/oopbuy-spreadsheet' },
  ],
  resources: [
    { label: 'Shopping Guide', to: '/guide/shopping' },
    { label: 'Beginner Guide', to: '/article/cssbuy-spreadsheet-guide' },
    { label: 'Trusted Sellers', to: '/article/trusted-cssbuy-sellers' },
    { label: 'QC Tutorials', to: '/article/cssbuy-spreadsheet-guide' },
    { label: 'Shipping Tips', to: '/article/cssbuy-spreadsheet-guide' },
  ],
  legal: [
    { label: 'Privacy Policy', to: '/' },
    { label: 'Terms of Service', to: '/' },
    { label: 'Disclaimer', to: '/' },
    { label: 'Contact', to: '/' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-lg font-heading font-bold text-foreground-950">
                CSSBuy <span className="text-primary-500">Spreadsheet</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              Your ultimate directory for CSSBuy spreadsheets, trusted sellers, buying guides, and shopping resources. Updated daily with fresh spreadsheet finds across all categories and agents.
            </p>
            <div className="flex items-center gap-3">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 hover:bg-primary-100 text-foreground-500 hover:text-primary-500 transition-colors">
                <i className="ri-global-line"></i>
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 hover:bg-primary-100 text-foreground-500 hover:text-primary-500 transition-colors">
                <i className="ri-shopping-cart-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4 text-sm">Explore</h4>
            <ul className="space-y-2.5">
              {footerLinks.explore.map((link) => (
                <li key={link.label}>
                  {link.to ? (
                    <Link to={link.to} className="text-sm text-foreground-500 hover:text-primary-500 transition-colors">
                      {link.label}
                    </Link>
                  ) : (
                    <a href={link.href} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors">
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4 text-sm">Agent Hubs</h4>
            <ul className="space-y-2.5">
              {footerLinks.agent_hubs.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-foreground-500 hover:text-primary-500 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4 text-sm">Resources</h4>
            <ul className="space-y-2.5">
              {footerLinks.resources.map((link) => (
                <li key={link.label}>
                  {link.to ? (
                    <Link to={link.to} className="text-sm text-foreground-500 hover:text-primary-500 transition-colors">
                      {link.label}
                    </Link>
                  ) : (
                    <a href={link.href} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors">
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4 text-sm">Legal</h4>
            <ul className="space-y-2.5">
              {footerLinks.legal.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-foreground-500 hover:text-primary-500 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} CSSBuy Spreadsheet. All rights reserved. This site is an independent resource and is not affiliated with CSSBuy or any shopping agent.
          </p>
          <p className="text-xs text-foreground-400">
            Visit our main site:{' '}
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-primary-500 hover:text-primary-600 transition-colors font-medium">
              kaspreadsheet.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}